import DraggableRow from "@/Components/DraggableRow/DraggableRow";
import { reorder } from "@/shared/utils/helpers";
import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

const DeliveryMethods = () => {
  const { t } = useTranslation("", { keyPrefix: "settings_page" });
  const { control } = useFormContext();

  return (
    <Controller
      name="deliveryMethods"
      control={control}
      render={({ value: deliveryMethods, onChange }) => (
        <DraggableRow
          label={t("deliveryMethods")}
          hint={t("cards.dragToSort")}
          variant="card"
          droppableId="deliveryMethodDroppableId"
          onDrageEnd={({ destination, source }) => {
            if (!destination) {
              return;
            }
            onChange(reorder(deliveryMethods, source.index, destination.index));
          }}
          list={deliveryMethods.map((item) => ({
            key: item.label,
            component: <div>{item.label}</div>,
          }))}
        />
      )}
    />
  );
};

export default DeliveryMethods;
